import { MailingList } from "../../../mailing-list/types";

export const mailingingListSubscription = (
  mailingList: MailingList
): string => {
  return `/mailing-lists/${mailingList}/subscriptions`;
};
